import * as React from 'react'
import {ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {StyledDiv, StyledImg, StyledLi, StyledUl} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {BreakPoint, Colors, DispWidthSize, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {FlexGrowContent, FlexStaticContent, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import NatMenuMasterRepo from '../menuMaster/repository/NatMenuMasterRepo'
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo'
import NatLoginRepo from '../login/repository/NatLoginRepo'
import NatResidentMenuMasterComponent from '../menuMaster/resident/NatResidentMenuMasterComponent'
import {generateMedia} from 'styled-media-query'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {NatGetMenuMasterAuthedResident} from '../menuMaster/repository/NatGetMenuMasterAuthedResident'
import {NatGetResidentUserAuthed} from '../residentUser/repository/NatGetResidentUserAuthed'
import {convertToRoomNumberForResident, judgeAuthorityCheck, NatAsyncCallFunction} from '../../common/util/Natutil'
import equal from 'fast-deep-equal'
import {PlainAncerLink} from '../../../styledComponents/Links'
import {Box} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import EventEmitterExResident from '../../../components/shared/pageBaseComponents/EventEmitterExResident'
import {Messages} from '../../../Messages'
import NatSessionRepo from '../session/repository/NatSessionRepo'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import {NatGetSmoothEAvailable} from '../residentUser/repository/NatGetSmoothEAvailable'
import {
    ASSOC_DIRECTOR_FLAG,
    HAVE_OR_NOT,
    LOGIN_MODE,
    ROLE_FOR_RESIDENT_REAL,
    ROLE_TYPE,
    VALID_OR_NOT
} from '../../../CodeMaster'
import {Assoc} from '../assocWorkReports/repository/NatGetAssocInfos'
import {NatAssocWorkReportRepo} from '../assocWorkReports/repository/NatAssocWorkReportRepo'
import {
    NatResidentLoginInfoSessionStorageHelper, ResidentLoginInfoSessionStorageKey,
} from '../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {Location, NavigateFunction} from 'react-router-dom'
import {NatCreateLogoutUrl} from '../residentUser/repository/NatCreateLogoutUrl';
import NatDisasterRepo from '../disaster/repository/NatDisasterRepo';
import {currentMedia} from '../../../styledComponents/ResponsiveConvenience';
import {MainContainer} from '../../../styledComponents/ContentsArea';
import ResidentGeneralMeetingRepo, {
    GetUnitOwnerByLoginUserRoomResponse,
    GetUnitOwnershipByLoginUserResponse,
    UnitOwner
} from '../../../components/generalMeeting/ResidentGeneralMeetingRepo'
import {HKConstants} from '../../../HKConstants'


const KEY_LOGIN_MODE: string = 'loginMode'
const KEY_SELECTED_CONDOMINIUM_NAME: string = 'selectedCondominiumName'
const KEY_LOGIN_FAMILY_NAME: string = 'loginFamilyName'
const KEY_LOGIN_FIRST_NAME: string = 'loginFirstName'
const KEY_SELECTED_RIDGENAME: string = 'selectedRidgeName'
const KEY_SELECTED_ROOM_NUMBER: string = 'selectedRoomNumber'
const ROLE_ID: string = 'role'

interface Props {
    loginedFlg: boolean
    navigate: NavigateFunction
    location: Location
    menuMasterRepo: NatMenuMasterRepo
    residentUserRepo: NatResidentUserRepo
    loginRepo: NatLoginRepo
    assocWorkReportRepo: NatAssocWorkReportRepo
    disasterRepo: NatDisasterRepo
    mypageFlg?: boolean
    isNoTransitionFlg?: boolean
    sessionRepo: NatSessionRepo,
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
}

interface States {
    menuMasterList: NatGetMenuMasterAuthedResident | null,
    unitOwnerByLoginUserRoom: Nullable<UnitOwner>
    unitOwnershipByLoginUser: Nullable<HAVE_OR_NOT>
    residentUserInfo: NatGetResidentUserAuthed | null,
    smoothEAvailable: NatGetSmoothEAvailable | null,
    changeLoginSiteToAdminAvailability: boolean
    isLoadCompleted: boolean
    currentUrl: string
    hamburgerMenuOpenFlag: boolean
    referrableManagementAssociationsExist: boolean
    disasterMode: boolean
}

interface ExternalProps {
    eventEmitter: EventEmitterExResident
}

class NatResidentHeaderAreaComponent extends React.Component<Props & ExternalProps, States> {
    constructor(props: Props & ExternalProps) {
        super(props)
        this.state = {
            menuMasterList: null,
            unitOwnerByLoginUserRoom: null,
            unitOwnershipByLoginUser: null,
            residentUserInfo: null,
            smoothEAvailable: null,
            changeLoginSiteToAdminAvailability: false,
            isLoadCompleted: false,
            currentUrl: this.props.location.pathname,
            hamburgerMenuOpenFlag: false,
            referrableManagementAssociationsExist: false,
            disasterMode: false,
        }

        this.backUserSettingButtonClick = this.backUserSettingButtonClick.bind(this)
        this.setHamburgerMenuOpenFlag = this.setHamburgerMenuOpenFlag.bind(this)
        this.updateUnitOwnerInformation = this.updateUnitOwnerInformation.bind(this)
        this.logoClick = this.logoClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        if (!this.props.loginedFlg) {
            await NatAsyncCallFunction(this.props.sessionRepo.postResidentUseSite.bind(
                this.props.sessionRepo,
            ), this.props.navigate)
            this.setState({isLoadCompleted: true})
        } else {
            await this.setDisasterMode()
            await this.setHeaderDate()
        }
    }

    async componentDidUpdate(prevProps: Props, prevState: States): Promise<void> {
        if (!this.props.loginedFlg) {
            await NatAsyncCallFunction(this.props.sessionRepo.postResidentUseSite.bind(
                this.props.sessionRepo,
            ), this.props.navigate)
        }
        if (!equal(prevProps.loginedFlg, this.props.loginedFlg)) {
            if (this.props.loginedFlg) {
                await this.setHeaderDate()
                this.setState({hamburgerMenuOpenFlag: false})
            }
        }
        if (this.props.mypageFlg &&
            this.props.location.pathname !== prevProps.location.pathname &&
            prevState.isLoadCompleted) {
            /**
             * 解除後に素敵ネットTOPに遷移したときに一瞬バナーが表示されてしまうための対策
             * バナーを一旦非表示にするようにState更新、コールバックで災害時モード設定状況を取得させる
             * 初回アクセス（前回のisLoadCompletedがfalse）の場合は、モード設定状況の取得は不要
             * （componentDidMount側で災害時モード設定状況を取得しているため）
             */
            this.setState({disasterMode: false}, async () => {
                await this.setDisasterMode()
            })
        }
        if (prevState.currentUrl !== this.props.location.pathname) {
            this.setState({currentUrl: this.props.location.pathname})
            if (
                // 区分所有者の状態が変更される場合の遷移後の画面パスを追加する
                this.props.location.pathname === '/resident/general-meeting/unit-owner-confirmation-complete' ||
                this.props.location.pathname.match(/^\/resident\/condominiums\/\d+\/ridges\/\d+\/rooms\/\d+\/users$/)
            ) {
                await this.updateUnitOwnerInformation()
            }
        }
    }

    async setHeaderDate(): Promise<void> {

        try {
            // 区分所有者・区分所有権確認(総会)
            // menuMasterListのsetStateによりメニューがrenderされるため先に総会メニュー表示の判定に必要な値をセットする
            await this.updateUnitOwnerInformation()

            // メニューマスタ取得
            const retMenuMaster: Nullable<NatGetMenuMasterAuthedResident> = await NatAsyncCallFunction(
                this.props.menuMasterRepo.getMenuMasterAuthedResident.bind(
                    this.props.menuMasterRepo), this.props.navigate)

            const retReferrableManagementAssociationsExist = await this.getReferrableManagementAssociationsExist()
            this.setState({
                referrableManagementAssociationsExist: retReferrableManagementAssociationsExist,
            })

            if (retMenuMaster) {
                this.setState({
                    menuMasterList: retMenuMaster,
                })
                if (retMenuMaster.details && retMenuMaster.details.length === 0) {
                    // メニューが存在しない場合はエラー画面に遷移する
                    this.props.navigate(
                        `/resident/error`,
                        {state: {message: Messages.EOPCC0042.toString('居住者様向けサービス')}},
                    )
                    return
                }
            }

            // 居住者情報取得
            const retResidentUser: Nullable<NatGetResidentUserAuthed> = await NatAsyncCallFunction(
                this.props.residentUserRepo.getResidentUserLogined.bind(
                    this.props.residentUserRepo), this.props.navigate)

            if (retResidentUser) {
                this.setState({
                    residentUserInfo: retResidentUser,
                })
            }

            if (SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_MODE) === LOGIN_MODE.RESIDENT.value) {
                // smooth-e利用可否取得
                const retSmoothEAvailable: Nullable<NatGetSmoothEAvailable> = await NatAsyncCallFunction(
                    this.props.residentUserRepo.getSmoothEAvailable.bind(
                        this.props.residentUserRepo), this.props.navigate)

                if (retSmoothEAvailable) {
                    this.setState({
                        smoothEAvailable: retSmoothEAvailable,
                    })
                }
            } else {
                this.setState({
                    smoothEAvailable: null,
                })
            }

            // 管理画面への切り替え可否情報を取得
            const changeLoginSiteToAdminAvailability: Nullable<boolean> = await NatAsyncCallFunction(
                this.props.sessionRepo.getChangeLoginSiteToAdminAvailability.bind(this.props.sessionRepo),
                this.props.navigate,
            )
            if (changeLoginSiteToAdminAvailability !== null) {
                this.setState({
                    changeLoginSiteToAdminAvailability: changeLoginSiteToAdminAvailability,
                })
            }
        } catch (HttpError) {
            // smooth-e利用可否取得のHTTPエラーは無視
        } finally {
            this.setState({
                isLoadCompleted: true,
            })
        }
    }

    async setDisasterMode(): Promise<void> {
        const selectedCondominiumCd = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD)
        const roleId = SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.ROLE)
        if (selectedCondominiumCd != null && !(roleId === ROLE_FOR_RESIDENT_REAL.BEFORE_OCCUPANCY.value)) {
            const disasterModeSetting = await NatAsyncCallFunction(
                this.props.disasterRepo.getDisasterMode.bind(
                    this.props.disasterRepo, selectedCondominiumCd), this.props.navigate,
            )
            this.setState({
                disasterMode: disasterModeSetting?.mode === VALID_OR_NOT.VALID.value
            })
        }
    }

    async updateUnitOwnerInformation(): Promise<void> {
        try {
            await this.props.eventEmitter.showLoading()
            if (!judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_UNIT_OWNER_CONFIRMATION)) {
                return
            }
            if (SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_MODE) !== LOGIN_MODE.RESIDENT.value) {
                return
            }
            const getUnitOwnerByLoginUserRoomResponse: Nullable<GetUnitOwnerByLoginUserRoomResponse>
                = await NatAsyncCallFunction(
                this.props.residentGeneralMeetingRepo.getUnitOwnerByLoginUserRoom.bind(
                    this.props.residentGeneralMeetingRepo
                ),
                this.props.navigate,
            )
            if (!getUnitOwnerByLoginUserRoomResponse) {
                throw new Error('区分所有者の取得に失敗しました。')
            }

            const getUnitOwnershipByLoginUserResponse: Nullable<GetUnitOwnershipByLoginUserResponse>
                = await NatAsyncCallFunction(
                this.props.residentGeneralMeetingRepo.getUnitOwnershipByLoginUser.bind(
                    this.props.residentGeneralMeetingRepo
                ),
                this.props.navigate,
            )
            if (!getUnitOwnershipByLoginUserResponse) {
                throw new Error('区分所有権の取得に失敗しました。')
            }

            this.setState({
                unitOwnerByLoginUserRoom: getUnitOwnerByLoginUserRoomResponse.details,
                unitOwnershipByLoginUser: getUnitOwnershipByLoginUserResponse.details,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async getReferrableManagementAssociationsExist(): Promise<boolean> {
        const loginMode = NatResidentLoginInfoSessionStorageHelper.getStringItemOrNull('loginMode')
        const assocDirectorFlag = NatResidentLoginInfoSessionStorageHelper.getStringItemOrNull('assocDirectorFlag')

        if (loginMode === LOGIN_MODE.ADMIN.value ||
            assocDirectorFlag === ASSOC_DIRECTOR_FLAG.TRUE.value) {
            const assocInfosResponse = await this.getAssocInfo()
            return assocInfosResponse.length >= 1
        }

        return false
    }

    async getAssocInfo(): Promise<Assoc[]> {
        const condominiumCd = NatResidentLoginInfoSessionStorageHelper.getStringItemOrNull('selectedCondominiumCd')

        if (!condominiumCd) {
            return []
        }
        const response = await NatAsyncCallFunction(
            this.props.assocWorkReportRepo.getAssocs.bind(
                this.props.assocWorkReportRepo, condominiumCd), this.props.navigate)

        return response?.details ? response.details.assocList : []
    }

    // ロゴ クリック
    logoClick(): void {
        if (this.props.loginedFlg) {
            this.props.navigate('/resident/mypage')
        }
    };

    // よくある質問 クリック
    faqClick(): void {
        window.open('/resources/contents/faq/residentFaq.pdf', '_blank')
    };

    // ログアウト クリック
    async backUserSettingButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // アプリの場合はreturn
            const isSutekiNetSmartPhoneApplication = SessionStorageHelper
                .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')

            if (isSutekiNetSmartPhoneApplication === 'true') {
                return;
            }
            const roleId = SessionStorageHelper.getStringItemOrNull(ROLE_ID)
            if (roleId !== null && roleId.slice(0, 1) === ROLE_TYPE.RESIDENT.value) {
                // ログアウト
                // 新G基盤ログアウト要求URL作成
                const natCreateLogoutUrl: Nullable<NatCreateLogoutUrl> =
                    await NatAsyncCallFunction(
                        this.props.residentUserRepo.createLogout.bind(
                            this.props.residentUserRepo), this.props.navigate, this.systemErrorTransition);
                if (natCreateLogoutUrl && natCreateLogoutUrl.details) {
                    // 新G基盤ログアウト要求
                    window.location.href = natCreateLogoutUrl.details;
                }
            } else {
                try {
                    // ログアウト
                    await this.props.loginRepo.postLogout()
                } finally {
                    this.props.eventEmitter.closeLoading()
                    // セッションストレージを全削除
                    SessionStorageHelper.removeAllItem()
                    this.props.navigate(
                        `/resident/login`,
                    )
                }
            }
        } catch (HttpError) {
            // 連携対象の会員情報が不足
            this.systemErrorTransition()
            return;
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    };

    // システムエラー遷移
    systemErrorTransition(): void {
        this.props.navigate(`/resident/error`,
            {
                state: {
                    message: Messages.ESYCC0015.toString(),
                }
            })
    }

    // 物件情報
    renderCondominiumInfo(): Nullable<ReactElement> {
        if (!this.props.loginedFlg) {
            // 未ログインの場合は、非表示
            return null
        }
        return (
            <HeaderPcCondominium>
                <ResidenComdominiumFlexPc>
                    <CondminuumIcon/>
                    <Box padding={`5px`}>
                        {SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_NAME)}
                    </Box>
                </ResidenComdominiumFlexPc>
            </HeaderPcCondominium>
        )
    }

    // ユーザ情報
    renderUserInfo(): Nullable<ReactElement> {
        if (!this.props.loginedFlg) {
            // 未ログインの場合は、非表示
            return null
        }
        return (
            <HeaderPcUser>
                <ResidenUserFlexPc>
                    <UserInfoIcon/>
                    <div>
                        <UserInfo>
                            {
                                SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_RIDGENAME) +
                                ' ' +
                                convertToRoomNumberForResident(
                                    SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_ROOM_NUMBER))
                            }
                        </UserInfo>
                        <UserInfo>
                            {
                                SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_FAMILY_NAME) +
                                ' ' +
                                SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_FIRST_NAME)
                            }
                        </UserInfo>
                    </div>
                </ResidenUserFlexPc>
            </HeaderPcUser>
        )
    }

    // 物件/ユーザ情報
    renderCondominiumAndUserInfo(): Nullable<ReactElement> {
        if (!this.props.loginedFlg) {
            return null
        }

        return (
            <FlexSpContent>
                <ResidentFlexUserComdominiumSp>
                    <ResidentFlexComdominiumItemSp>
                        <CondminuumIcon/>
                        <BuildingInfo>
                            {SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_NAME)}
                        </BuildingInfo>
                    </ResidentFlexComdominiumItemSp>
                    <ResidentFlexUserItemSp>
                        <UserInfoIcon/>
                        <div>
                            <BuildingInfo>
                                {
                                    SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_RIDGENAME) +
                                    ' ' +
                                    convertToRoomNumberForResident(
                                        SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_ROOM_NUMBER))
                                }
                            </BuildingInfo>
                            <BuildingInfo>
                                {
                                    SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_FAMILY_NAME) +
                                    ' ' +
                                    SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_FIRST_NAME)
                                }
                            </BuildingInfo>
                        </div>
                    </ResidentFlexUserItemSp>
                </ResidentFlexUserComdominiumSp>
            </FlexSpContent>
        )
    }

    // 災害時モード　詳細を見るボタンクリック
    private handleDisasterModeDetailButtonClick = () => {
        const condominiumCd = NatResidentLoginInfoSessionStorageHelper.getStringItemOrNull('selectedCondominiumCd')
        if (!condominiumCd) {
            return null
        }
        this.props.navigate(`/resident/condominiums/${condominiumCd}/disasters/prevention/top`)
    }

    // 災害時モードラベル
    renderDisasterMode(): Nullable<ReactElement> {
        if (!this.state.disasterMode) {
            return null
        }
        return (
            <DisasterModeArea>
                <DisasterModeContainer>
                    <StyledDisasterModeLabel>
                        <DisasterModeMainBlock>
                            <DisasterModeIconImg src={`/resources/images/icons/icon_exclamation.png`}
                                                 alt="災害時モード"/>
                            <DisasterModeTextComponent>
                                <DisasterModeMainTextWrapper>
                                    <DisasterModeMainText>災害対応中</DisasterModeMainText>
                                </DisasterModeMainTextWrapper>
                                <DisasterModeSubText>情報共有にご協力ください</DisasterModeSubText>
                            </DisasterModeTextComponent>
                        </DisasterModeMainBlock>
                        <DisasterModeButton onClick={this.handleDisasterModeDetailButtonClick}>
                            <DisasterModeButtonComponent>
                                <DisasterModeButtonText>詳細を見る</DisasterModeButtonText>
                                <StyledNavigateNextIcon/>
                            </DisasterModeButtonComponent>
                        </DisasterModeButton>
                    </StyledDisasterModeLabel>
                </DisasterModeContainer>
            </DisasterModeArea>
        )
    }

    // ログアウト
    renderLogout(): Nullable<ReactElement> {
        if (!this.props.loginedFlg) {
            // 未ログインの場合は、非表示
            return null
        }
        return (
            <HeaderPcFaqAndLogout>
                <HeaderImgClickWrapper onClick={this.backUserSettingButtonClick}>
                    <FlexButton>
                        <HeaderLogoutImgPc
                            src={`/resources/images/icons/icon_logout.png`}
                            alt="ログアウト"/>
                    </FlexButton>
                    <span id={'logoutBtn'}>ログアウト</span>
                </HeaderImgClickWrapper>
            </HeaderPcFaqAndLogout>
        )
    }

    // ハンバーガーメニュー
    renderHamburgerMenu(): Nullable<ReactElement> {
        if (!this.props.loginedFlg) {
            // 未ログインの場合は、非表示
            return null
        }
        return (
            <>
                <HeaderSpHamburgerMenu id={'headerSpHamburgerMenu'}>
                    <HeaderImgWrapper>
                        <NatResidentMenuMasterComponent
                            navigate={this.props.navigate}
                            location={this.props.location}
                            menuMasterRepo={this.props.menuMasterRepo}
                            menuMasterList={this.state.menuMasterList}
                            unitOwnerByLoginUserRoom={this.state.unitOwnerByLoginUserRoom}
                            unitOwnershipByLoginUser={this.state.unitOwnershipByLoginUser}
                            residentUserInfo={this.state.residentUserInfo}
                            smoothEAvailable={this.state.smoothEAvailable}
                            changeLoginSiteToAdminAvailability={this.state.changeLoginSiteToAdminAvailability}
                            loginRepo={this.props.loginRepo}
                            sessionRepo={this.props.sessionRepo}
                            eventEmitter={this.props.eventEmitter}
                            loginedFlg={this.props.loginedFlg}
                            setHamburgerMenuOpenFlag={this.setHamburgerMenuOpenFlag}
                            referrableManagementAssociationsExist={this.state.referrableManagementAssociationsExist}
                            residentUserRepo={this.props.residentUserRepo}
                        />
                    </HeaderImgWrapper>
                    {(this.state.hamburgerMenuOpenFlag) ? '閉じる' : 'メニュー'}
                </HeaderSpHamburgerMenu>

            </>
        )
    }

    setHamburgerMenuOpenFlag(hamburgerMenuOpenFlag: boolean): void {
        this.setState({
            hamburgerMenuOpenFlag: hamburgerMenuOpenFlag,
        })
    }

    // 居住者画面メニュー
    renderResidentMenu(): Nullable<ReactElement> {
        if (!this.props.loginedFlg) {
            // 未ログインの場合は、非表示
            return null
        }
        return (
            <FlexPcContent>
                <NatResidentMenuMasterComponent
                    navigate={this.props.navigate}
                    location={this.props.location}
                    menuMasterRepo={this.props.menuMasterRepo}
                    menuMasterList={this.state.menuMasterList}
                    unitOwnerByLoginUserRoom={this.state.unitOwnerByLoginUserRoom}
                    unitOwnershipByLoginUser={this.state.unitOwnershipByLoginUser}
                    residentUserInfo={this.state.residentUserInfo}
                    smoothEAvailable={this.state.smoothEAvailable}
                    changeLoginSiteToAdminAvailability={this.state.changeLoginSiteToAdminAvailability}
                    loginRepo={this.props.loginRepo}
                    sessionRepo={this.props.sessionRepo}
                    eventEmitter={this.props.eventEmitter}
                    loginedFlg={this.props.loginedFlg}
                    referrableManagementAssociationsExist={this.state.referrableManagementAssociationsExist}
                    residentUserRepo={this.props.residentUserRepo}
                />
            </FlexPcContent>
        )
    }

    // よくある質問(PC)
    renderPcHeaderFaqButton(): Nullable<ReactElement> {
        if (this.props.isNoTransitionFlg) {
            return null
        }
        return (
            <HeaderPcFaqAndLogout>
                <HeaderImgClickWrapper onClick={this.faqClick}>
                    <FlexButton>
                        <HeaderFaqImgPc
                            src={`/resources/images/icons/FAQ.svg`}
                            alt="よくある質問"/>
                    </FlexButton>
                    <span>よくある質問</span>
                </HeaderImgClickWrapper>
            </HeaderPcFaqAndLogout>
        )
    }

    // よくある質問(SP)
    renderSpHeaderFaqButton(): Nullable<ReactElement> {
        if (this.props.isNoTransitionFlg) {
            return null
        }
        return (
            <HeaderSpFaq>
                <HeaderImgWrapper>
                    <FlexAncerLink href={'/resources/contents/faq/residentFaq.pdf'} target={'_blank'}>
                        <HeaderFaqImgSp src={`/resources/images/icons/FAQ.svg`}
                                        alt="よくある質問"/>
                    </FlexAncerLink>
                </HeaderImgWrapper>
                <span>よくある質問</span>
            </HeaderSpFaq>
        )
    }

    renderPcHeader(): ReactElement {
        return (
            <ResidentFlexHeaderBack>
                <StyledNavigationHeader>
                    <HeaderFlex>
                        <HeaderSiteLogo>
                            <HeaderImgWrapper>
                                <FlexAncerLink
                                    onClick={(event: React.MouseEvent) => {
                                        event.preventDefault()
                                        this.logoClick()
                                    }}
                                    style={{
                                        cursor: `${(this.props.loginedFlg) ? 'pointer' : 'default'}`,
                                    }}>
                                    <HeaderImg
                                        src={`/resources/images/residents_logo.png`}
                                        alt="マンションライフをもっと笑顔にすまいるネット"/>
                                </FlexAncerLink>
                            </HeaderImgWrapper>
                        </HeaderSiteLogo>
                        {this.renderCondominiumInfo()}
                        {this.renderUserInfo()}
                        {this.renderPcHeaderFaqButton()}
                        {this.renderLogout()}
                    </HeaderFlex>
                </StyledNavigationHeader>
            </ResidentFlexHeaderBack>
        )
    }

    renderSpHeader(): ReactElement {
        return (
            <ResidentFlexHeaderBack>
                <HeaderFlex>
                    <HeaderSiteLogo>
                        <HeaderImgWrapper>
                            <FlexAncerLink
                                onClick={(event: React.MouseEvent) => {
                                    event.preventDefault()
                                    this.logoClick()
                                }}
                                style={{
                                    cursor: `${(this.props.loginedFlg) ? 'pointer' : 'default'}`,
                                }}>
                                <HeaderImg src={`/resources/images/residents_logo.png`}
                                           alt="マンションライフをもっと笑顔にすまいるネット"/>
                            </FlexAncerLink>
                        </HeaderImgWrapper>
                    </HeaderSiteLogo>
                    {this.renderSpHeaderFaqButton()}
                    {this.renderHamburgerMenu()}
                </HeaderFlex>
            </ResidentFlexHeaderBack>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <FlexPcContent>
                    {this.renderPcHeader()}
                </FlexPcContent>
                <FlexSpContent>
                    {this.renderSpHeader()}
                </FlexSpContent>
                {this.renderCondominiumAndUserInfo()}
                {this.props.mypageFlg && this.state.disasterMode ? this.renderDisasterMode() : ''}
                {this.renderResidentMenu()}
                {(this.props.mypageFlg !== undefined && this.props.mypageFlg) ?
                    <NatResidentMenuMasterComponent
                        navigate={this.props.navigate}
                        location={this.props.location}
                        menuMasterRepo={this.props.menuMasterRepo}
                        menuMasterList={this.state.menuMasterList}
                        unitOwnerByLoginUserRoom={this.state.unitOwnerByLoginUserRoom}
                        unitOwnershipByLoginUser={this.state.unitOwnershipByLoginUser}
                        residentUserInfo={this.state.residentUserInfo}
                        smoothEAvailable={this.state.smoothEAvailable}
                        changeLoginSiteToAdminAvailability={this.state.changeLoginSiteToAdminAvailability}
                        loginRepo={this.props.loginRepo}
                        sessionRepo={this.props.sessionRepo}
                        mypageFlg={true}
                        eventEmitter={this.props.eventEmitter}
                        loginedFlg={this.props.loginedFlg}
                        referrableManagementAssociationsExist={this.state.referrableManagementAssociationsExist}
                        residentUserRepo={this.props.residentUserRepo}
                    /> : ''}
            </>
        )
    }
}

export default NatResidentHeaderAreaComponent

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

// PC表示/SP非表示
const FlexPcContent: StyledDiv = styled.div`
  display: block;

  ${breakPoint.lessThan('sp')`
    display: none;
  `}
`
// PC非表示/SP表示
const FlexSpContent: StyledDiv = styled.div`
  display: none;

  ${breakPoint.lessThan('sp')`
    display: block;
  `}
`

// ヘッダーエリア（Back）
const ResidentFlexHeaderBack = styled(FlexStaticContent)`
  background-color: ${Colors.Primary};
`

// ヘッダーエリア（Flex）
const HeaderFlex: StyledUl = styled.ul`
  display: flex;
  justify-content: space-between;
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  color: ${Colors.Surface};
`

// ヘッダーエリア
const StyledNavigationHeader = styled(RowFlexContainer)`
  position: relative;
  max-width: ${DispWidthSize.MaxWidth};
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  z-index: 10;
  box-shadow: 6px 0 5px -5px ${Colors.Shadow}, -6px 0 5px -5px ${Colors.Shadow};
  background-color: ${Colors.Primary};
  color: ${Colors.Surface};
  font-size: ${FontSize.Small};
`

// 画像ラッパー
const HeaderImgWrapper: StyledDiv = styled.div`
  height: 100%;
  min-height: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${breakPoint.lessThan('sp')`
    height: auto;
  `}
`

// 画像
const HeaderImg: StyledImg = styled.img`
  width: 100%;
  height: auto;
  flex-shrink: 0;
  vertical-align: bottom;
`

// 画像ラッパー(Click)
const HeaderImgClickWrapper = styled(HeaderImgWrapper)`
  cursor: pointer;
`

// Ancer
const FlexAncerLink = styled(PlainAncerLink)`
  min-height: 0;
`

// Button
const FlexButton: StyledDiv = styled.div`
  display: inline-block;
  min-height: 0;
`

// Flex Item(Logo)
const HeaderSiteLogo: StyledLi = styled.li`
  display: flex;
  align-content: center;
  text-align: center;
  position: relative;
  align-items: center;
  margin-left: 0;
  flex-grow: 1;
  padding: 0 15px 0 15px;
  min-height: 80px;
  box-sizing: border-box;

  ${breakPoint.lessThan('sp')`
     padding: 0;
     margin-left: 15px;
     flex-grow: 10;
  `}
`

// Flex Item(Condominium)
const HeaderPcCondominium = styled(HeaderSiteLogo)`
  padding: 0 15px 0 0;
  flex-basis: 300px;
`

// 物件エリア（Flex）
const ResidenComdominiumFlexPc: StyledDiv = styled.div`
  display: flex;
  align-items: center;
`

// Flex Item(User)
const HeaderPcUser = styled(HeaderSiteLogo)`
  justify-content: flex-end;
  flex-basis: 150px;
`

// ユーザエリア（Flex）
const ResidenUserFlexPc: StyledDiv = styled.div`
  display: flex;
  align-items: center;
`

// ユーザ情報
const UserInfo = styled(FlexGrowContent)`
  padding-left: 5px;
`

// Faq
const HeaderFaqImgPc = styled(HeaderImg)`
  width: 48px;
  height: 24px;
`

// Logout
const HeaderLogoutImgPc = styled(HeaderImg)`
  width: 27px;
  height: 24px;
`

// Flex Item(Faq/Logout)
const HeaderPcFaqAndLogout = styled(HeaderSiteLogo)`
  justify-content: flex-end;
`

// Flex Item(Faq) SP
const HeaderSpFaq = styled(HeaderSiteLogo)`
  ${breakPoint.lessThan('sp')`
    flex-direction: column;
　  font-size: ${FontSize.Small};
    align-items: center;
    margin-left: 0;
    flex-grow: 1;
    word-break: break-all;
  `}
`

// Flex Item(HamburgerMenu) SP
const HeaderSpHamburgerMenu = styled(HeaderSiteLogo)`
  ${breakPoint.lessThan('sp')`
    flex-direction: column;
    padding-right: 5px;
    font-size: ${FontSize.Small};
    align-items: center;
    flex-grow: 1;
    word-break: break-all;
  `}
`

// Faq
const HeaderFaqImgSp = styled(HeaderImg)`
  width: 48px;
  height: 48px;
`

// ユーザ/物件情報エリア（back）
const ResidentFlexUserComdominiumSp = styled(FlexStaticContent)`
  background-color: ${Colors.Surface};
  display: flex;
  align-items: center;
  font-size: ${FontSize.Small};
  padding: 8px;
`

// Flex Item(Condominium) SP
const ResidentFlexComdominiumItemSp: StyledDiv = styled.div`
  display: flex;
  align-items: center;
  width: 60%;
`

// Flex Item(User) SP
const ResidentFlexUserItemSp: StyledDiv = styled.div`
  display: flex;
  align-items: center;
  width: 40%;
`

// 物件アイコン
const CondminuumIcon: StyledDiv = styled.div`
  padding: 15px;
  margin: 5px;
  background-image: url(/resources/images/icons/icon_building_white.png);
  background-position: left;
  background-repeat: no-repeat;
  background-size: 24px;

  ${breakPoint.lessThan('sp')`
     background-image: url(/resources/images/icons/icon_building.png);
  `}
`

// ユーザアイコン
const UserInfoIcon = styled(CondminuumIcon)`
  background-image: url(/resources/images/icons/icon_user_white.png);
  ${breakPoint.lessThan('sp')`
     background-image: url(/resources/images/icons/icon_user.png);
  `}
`

// 物件情報
const BuildingInfo = styled(FlexGrowContent)`
  padding-left: 5px;
`

// 災害時モードエリア
const DisasterModeArea = styled(FlexStaticContent)`
    display: flex;
    justify-content: center
`
// 災害時モードラベルコンテナ
const DisasterModeContainer = styled(RowFlexContainer)`
    position: relative;
    width: ${DispWidthSize.MaxWidth};
    height: 64px;
    padding: 5px 0;
    background-color: ${Colors.Disaster};
    ${currentMedia.lessThan('sp')`
        margin-top: 15px;
  `}
`
// 災害時モードラベル
const StyledDisasterModeLabel = styled(MainContainer)`
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0 15px;
    align-items: center;
    background-color: ${Colors.Disaster};
    ${currentMedia.lessThan('sp')`
        height: 54px;
  `}
`
// 災害時モードメインブロック
const DisasterModeMainBlock = styled.div`
    display: inline-flex;
    align-items: center;
    background-color: ${Colors.Disaster};
    padding: 3px 0;
    ${currentMedia.lessThan('sp')`
        padding: 5px 0;
  `}
`
// 災害時モードアイコン
const DisasterModeIconImg: StyledImg = styled.img`
    width: 35px;
    height: 35px;
`
// 災害時モードテキストコンポーネント
const DisasterModeTextComponent = styled.div`
    display: flex;
    align-items: center;
    font-weight: ${FontWeights.Bold};
    margin-left: 10px;
    ${currentMedia.lessThan('sp')`
        flex-direction: column;
        width: 100%;
        justify-content: space-between;
   `}
`
// 災害時モードメインテキスト　※下線調整のためのラッパー
const DisasterModeMainTextWrapper = styled.div`
    display: inline-block;
    color: ${Colors.Surface};
    border-bottom: 1px solid;
    line-height: 30px;
`
// 災害時モードメインテキスト
const DisasterModeMainText = styled.div`
    margin-right: -11px;
    font-size: ${FontSize.Accent};
    font-weight: ${FontWeights.Bold};
    letter-spacing: 11px;
`
// 災害時モードサブテキスト
const DisasterModeSubText = styled.div`
    margin-left: 15px;
    font-size: ${FontSize.Small};
    color: ${Colors.Surface};
    ${currentMedia.lessThan('sp')`
        margin-left: 0px;
   `}
`
// 災害時モードボタン
const DisasterModeButton = styled.div`
    height: 40px;
    width: 180px;
    box-sizing: border-box;
    font-size: ${FontSize.Middle};
    display: flex;
    align-items: center;
    justify-content: center;
    border-style: solid;
    border-radius: 8px;
    border-width: 1px;
    border-color: ${Colors.Disaster};
    margin: 3px 0;

    background-clip: content-box;
    background-color: ${Colors.Surface};
    white-space: nowrap;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    box-shadow: 0 2px 0 0 ${Colors.DisasterShadow};

    ${currentMedia.lessThan('sp')`
        width: 134px;
        margin: 5px 0;
   `}
`
// 災害時モードボタン要素
const DisasterModeButtonComponent = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 0 10px;
`
// 災害時モードボタンテキスト
const DisasterModeButtonText = styled.div`
    flex-grow: 1;
    font-size: ${FontSize.Middle};
    font-weight: ${FontWeights.Bold};
    color: ${Colors.Disaster};
`
// 災害時モードボタンアイコン
const StyledNavigateNextIcon = withStyles({
    root: {
        fontSize: FontSize.Big,
        color: Colors.Disaster,
    },
})(NavigateNextIcon)
